const isProd = process.env.REACT_APP_STAGE === "production";

let url;
isProd
  ? (url = "https://us-central1-bancoazteca-master-hub.cloudfunctions.net")
  : (url = "http://localhost:5000/bancoazteca-master-hub/us-central1");

export default url;
